export const RETAIL_SESSION_EXPIRED_EVENT = "protego:retail-session-expired";
const OTP_TOKEN_STORAGE_KEY = "otp_access_token";

export const clearOtpTokenStorage = () => {
  if (typeof window === "undefined") return;

  localStorage.removeItem(OTP_TOKEN_STORAGE_KEY);
};

export const clearRetailSessionStorage = () => {
  clearOtpTokenStorage();
  if (typeof window === "undefined") return;
  localStorage.removeItem("resumeSessionData");
};

export const dispatchRetailSessionExpired = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(RETAIL_SESSION_EXPIRED_EVENT));
};
